import api from './client';

export const fetchPlanFeatureAssignments = (planId) =>
  api.get(`/admin/plans/${planId}/feature_assignments`);

export const savePlanFeatureAssignments = (planId, subFeatureIds) =>
  api.put(`/admin/plans/${planId}/feature_assignments`, { sub_feature_ids: subFeatureIds });
